import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/DescriptionList/DescriptionList.tsx
import React from "react";
import clsx from "clsx";
var DescriptionList = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */React.createElement("dl", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd-descriptionlist", className)
  }), children);
};
var DescriptionList_default = DescriptionList;
export { DescriptionList_default };